import { CircularProgress, Grid, Paper, Typography } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState, useContext, useRef } from "react";
import Button from "@mui/material/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { baseUrlRate, LOCAL_STORAGE_KEY } from "../../../config";
import { path } from "../../../order_managment/constants/apiPath";
import { getUserData } from "../../common/utility/Utils";
import DailogueRms from "./DailogueRms";
import routeConstant from "../../../route/compoent/routeConstant";
import { StoreContext } from "../../../store/Provider";
import Counter from "./Counter";
import QuotesCard from "./QuotesCard";

const QuoteDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [freightRate, setfreightRate] = useState([]);
  const [dailogueOpen, setDailogueOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [quoteResult, setQuoteResult] = useState({});
  const [quoteArr, setQuoteArr] = useState([]);
  const [loadingbutton, setLoadingbutton] = useState(null);
  console.log("freightRate.state", freightRate);
  const { lmdResponse } = useContext(StoreContext);
  const [qouteId, setQuoteId] = useState("default");
  const objref = useRef([]);
  console.log(objref, "ob is ");
  const getRateFreight = async () => {
    setLoading(true);
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    let url, body;
    if (location.state.status === "LCL") {
      url = `${baseUrlRate}${path.GET_FREIGHT_RATE}`;
      body = {
        fromCode: location.state?.origin?.originCode ?? "",
        toCode: location.state?.destination.destinationCode ?? "",
        quantity: location.state?.cbm ? location.state?.cbm : "",
        isCustomClearanceOpted: JSON.parse(
          location.state.isCustomClearaceOpted
        ),
        isInsuranceOpted: JSON.parse(location.state.isInsuraceOpted),
        isLMDOpted: lmdResponse?.success
          ? JSON.parse(location.state.isLastMileSelected)
          : false,
        lmdRateIfAny: lmdResponse?.success
          ? lmdResponse?.rateEstimate?.netFreightCharge
          : 0,
      };
    }
    if (location.state.status === "FCL") {
      url = `${baseUrlRate}${path.GET_FCL_QUOTE}`;
      console.log("location.state", location.state);
      body = {
        fromCode: location.state?.origin?.originCode ?? "",
        toCode: location.state?.destination.destinationCode ?? "",
      };
      console.log("freightRate", "in fcl", body, url);
    }

    axios
      .post(url, body, {
        headers: header,
      })
      .then((res) => {
        console.log("resss", res);
        setLoading(false);
        setfreightRate(res.data?.quotes ?? []);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getRateFreight();
  }, []);
  const [clicked, setClicked] = useState(null);

  // console.log("Quote result: ", quoteResult?.quote_BookingId);

  const disableQuoteButton = (index) => {
    // setButtonDisable(index);
    let tempo = [...freightRate];

    const tempFreightRate = {
      ...freightRate[index],
      buttonDisable: true,
      quoteBookingId: quoteResult?.quote_BookingId,
    };
    tempo[index] = tempFreightRate;
    setfreightRate(tempo);
    // setfreightRate([...freightRate, (freightRate[index])]);
    // console.log("Temp Data: ", tempFreightRate);
    // setfreightRate(tempFreightRate)
  };
  // console.log("freightRate", freightRate);
  // console.log("QuoteDetails", location.state);
  const createQuote = async (item, index) => {
    setLoadingbutton(index);
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    let url, body;
    if (location.state.status === "LCL") {
      url = `${baseUrlRate}${path.CREATE_QUOTE}`;
      console.log(
        "createQuote item inside lcl",
        item?.ipiPrice?.id,
        "$$",
        index
      );

      body = {
        bookingMadeByUserId: data.user_name.split("@")[0],
        emailIdOfUser: data.user_name,
        bookingMadeForCompanyCode:
          location.state?.userType === "SALES"
            ? location.state?.saleCompanyCode?.organizationCode
            : location.state?.companyCode,
        freightQuoteAgainstPriceId: item?.lclPrice?.id ?? 1,
        freightQty: location.state?.cbm ?? 0,
        ipiQuoteAgainstPriceId: item?.ipiPrice?.id ?? 1,
        ipiQty: location.state?.cbm ?? 0,
        isLMDOpted:
          parseInt(location.state.weight) * 2204.62262185 > 50000 ||
          !lmdResponse?.success
            ? false
            : JSON.parse(location.state.isLastMileSelected),
        originZipCode: lmdResponse?.success
          ? location.state.destination.destinationZipCode ?? ""
          : "",
        destinationZipCode: lmdResponse?.success
          ? location.state.finalDestination ?? ""
          : "",
        lmdQuoteAmount: lmdResponse?.success
          ? lmdResponse?.rateEstimate?.netFreightCharge ?? 0
          : 0,
        lmdDestinationAddress: lmdResponse?.success
          ? location?.state?.lmdDestinationAddress ?? ""
          : "",
        lmdQuoteId: lmdResponse?.success
          ? lmdResponse?.referenceNumber ?? ""
          : "",
        lmdQuoteValidTill: "2099-03-29T10:55:42.674Z",
        totalQuotedAmount: item?.total_rate ?? 0,
        isInsuraceOpted: JSON.parse(location.state.isInsuraceOpted),
        isCustomClearaceOpted: JSON.parse(location.state.isCustomClearaceOpted),
        isHazardous: JSON.parse(location.state.isHazardous),
        pieceCount: location.state.pieceCount,
        weight: parseInt(location.state.weight),
        dimensionHeight: location.state.dimensionHeight,
        dimensionLength: location.state.dimensionLength,
        dimensionWidth: location.state.dimensionWidth,
        commodity: location.state.commodity,
      };
    } else if (location.state.status === "FCL") {
      url = `${baseUrlRate}${path.CREATE_FCL_QUOTE}`;

      body = {
        bookingMadeByUserId: data.user_name.split("@")[0],
        bookingMadeForCompanyCode:
          location.state?.userType === "SALES"
            ? location.state?.saleCompanyCode?.organizationCode
            : location.state?.companyCode,
        emailIdOfUser: data.user_name,
        commodity: location.state.commodity,
        isGP20ContainerSelected: objref.current?.[0]?.gP20 ?? false,
        isGP40ContainerSelected: objref.current?.[0]?.gP40 ?? false,
        isHQ40ContainerSelected: objref.current?.[0]?.hQ40 ?? false,
        isHQ45ContainerSelected: objref.current?.[0]?.hQ45 ?? false,
        isNOR40ContainerSelected: objref.current?.[0]?.noR40 ?? false,
        gP20ContainerCount: objref.current?.[1]?.gP20 ?? 0,
        gP40ContainerCount: objref.current?.[1]?.gP40 ?? 0,
        hQ40ContainerCount: objref.current?.[1]?.hQ40 ?? 0,
        hQ45ContainerCount: objref.current?.[1]?.hQ45 ?? 0,
        noR40ContainerCount: objref.current?.[1]?.noR40 ?? 0,
        gP20ContainerRate: objref.current?.[2]?.gP20 ?? 0,
        gP40ContainerRate: objref.current?.[2]?.gP40 ?? 0,
        hQ40ContainerRate: objref.current?.[2]?.hQ40 ?? 0,
        hQ45ContainerRate: objref.current?.[2]?.hQ45 ?? 0,
        noR40ContainerRate: objref.current?.[2]?.noR40 ?? 0,
        isInsuraceOpted: JSON.parse(location.state.isInsuraceOpted),
        isCustomClearaceOpted: JSON.parse(location.state.isCustomClearaceOpted),
        isHazardous: JSON.parse(location.state.isHazardous),
        signature: freightRate[index].signature,
        cY_Closing: freightRate[index].cY_Closing,
        carrier: freightRate[index].carrier,
        commodityType: freightRate[index].commodity,
        destination: freightRate[index].destination,
        etd: freightRate[index].etd,
        effectiveDate: freightRate[index].effectiveDate,
        expiringDate: freightRate[index].expiringDate,
        mode: freightRate[index].mode,
        pod: freightRate[index].pod,
        pol: freightRate[index].pol,
        routing: freightRate[index].routing,
        tT_to_POD: freightRate[index].tT_to_POD,
        via: freightRate[index].via,
      };
    }
    axios
      .post(url, body, {
        headers: header,
      })
      .then((res) => {
        setLoadingbutton(null);
        setQuoteResult(res?.data ?? res?.fclPricingDetails ?? {});
        let temp = [...quoteArr];
        temp.push(res?.data ?? res?.fclPricingDetails ?? {});
        setQuoteArr(temp);
        console.log("quoteArr", quoteArr);
        // setQuoteId(res.data.quote_BookingId ?? "");
        setDailogueOpen(true);
        disableQuoteButton(index);
      })
      .catch((err) => {
        setLoadingbutton(null);
        setQuoteResult({});
        console.log(err);
      });
  };
  // console.log("QuoteResult", quoteResult, quoteArr);
  // console.log("freightRate", freightRate);

  return (
    <>
      <div className="test">
        <Grid container style={{ flexDirection: "row" }}>
          {dailogueOpen ? (
            <DailogueRms
              status={location.state.status}
              dailogueOpen={dailogueOpen}
              setDailogueOpen={setDailogueOpen}
              quoteResult={quoteResult}
              details={location.state}
            />
          ) : null}
          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <CircularProgress size="2rem" />
            </div>
          ) : (
            <>
              {!freightRate.length ? (
                <Typography
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  No data found!
                </Typography>
              ) : (
                <>
                  <Grid item xs={12}>
                    <Typography sx={{ fontSize: "1.5rem" }}>
                      Available Quote(s) :
                      <span style={{ fontWeight: "bold", color: "#0069bf" }}>
                        {` ${freightRate.length}`}
                      </span>
                    </Typography>
                  </Grid>
                  {freightRate.map((item, index) => {
                    return (
                      <QuotesCard
                        item={item}
                        index={index}
                        setClicked={setClicked}
                        clicked={clicked}
                        createQuote={createQuote}
                        objref={objref.current}
                        freightRate={freightRate}
                        quoteArr={quoteArr}
                        loadingbutton={loadingbutton}
                        key={index}
                      />
                    );
                  })}
                  {/* <Grid item xs={12}>
                  <Paper elevation={3}>
                    <Typography
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "red",
                        padding: "0.3rem 0",
                      }}
                    >
                      This Quotation is subject to in and out warehouse charges
                    </Typography>
                  </Paper>
                </Grid> */}
                </>
              )}
            </>
          )}
        </Grid>
      </div>
    </>
  );
};

export default QuoteDetails;
